/* Copyright 2013 - 2024 Waiterio LLC */
export default [
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'fr',
  'id',
  'it',
  'nl',
  'pl',
  'pt',
  'ru',
  'th',
  'tl',
  'tr',
]
